<div class="page">
  @if (isLoading) {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="true" />
    </div>
  }
  @if (!isInitialLoading) {
    <div class="content-wrapper" [ngClass]="{ 'hide-while-loading': isLoading }">
      <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
      <div class="heading-wrapper">
        @if (!isLoading) {
          @if (!topicId) {
            <h4>{{ 'pages.researchTopic.titleAdd' | translate }}</h4>
          } @else {
            <h4>
              {{ 'pages.researchTopic.titleEdit' | translate }} -
              {{ researchTopic?.name }}
            </h4>
          }
        }
      </div>
      <form [formGroup]="form">
        <div class="section">
          <div class="lna-row full-width">
            <div class="label-wrapper">
              <label class="form-label lna" for="name">
                {{ 'pages.researchTopic.name' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-tooltip text="researchTopicNameBackoffice" />
            </div>
            <div class="textarea-wrapper">
              <textarea
                class="form-control lna"
                id="name"
                [ngClass]="{ invalid: shouldRenderError('name') }"
                type="text"
                formControlName="name"
                name="name"
                required
                maxlength="{{ maxFieldLength }}"></textarea>
              <p class="length" [ngClass]="{ invalid: name?.value.length > maxFieldLength }">
                {{ name?.value.length }}/{{ maxFieldLength }}
              </p>
            </div>
            @if (getErrorMessage('name'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message">
                  {{ errorMessage | translate }}
                </small>
              </div>
            }
          </div>
          <div class="lna-row full-width">
            <div class="label-wrapper">
              <label class="form-label lna" for="purpose">
                {{ 'pages.researchTopic.purpose' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-tooltip text="researchTopicPurposeBackoffice" />
            </div>
            <select id="purpose" [ngClass]="{ invalid: shouldRenderError('purpose') }" formControlName="purpose">
              <option class="empty-option" [value]="''" disabled>
                {{ 'pages.researchTopic.choosePurpose' | translate }}
              </option>
              <option class="empty-option" [value]="'WorkTask'">
                {{ 'pages.researchTopic.workTask' | translate }}
              </option>
              <option class="empty-option" [value]="'StudyResearch'">
                {{ 'pages.researchTopic.studyResearch' | translate }}
              </option>
              <option class="empty-option" [value]="'PrivateResearch'">
                {{ 'pages.researchTopic.privateResearch' | translate }}
              </option>
            </select>
            @if (getErrorMessage('purpose'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message">
                  {{ errorMessage | translate }}
                </small>
              </div>
            }
          </div>
          @if (hasWorkSection()) {
            <form class="work-form" [formGroup]="workForm">
              <div class="grid-2">
                <div class="lna-row full-width">
                  <label class="form-label lna" for="registrationNumber">
                    {{ 'pages.researchTopic.workRegistrationNumber' | translate }}
                    <span class="required-field">*</span>
                  </label>
                  <div class="textarea-wrapper short">
                    <textarea
                      class="form-control lna"
                      id="registrationNumberWork"
                      [ngClass]="{ invalid: shouldRenderError('registrationNumber') }"
                      type="text"
                      formControlName="registrationNumber"
                      name="registrationNumber"
                      required
                      maxlength="{{ maxLengthRegistrationNumber }}"></textarea>
                  </div>
                  @if (getErrorMessage('registrationNumber', workForm); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message">
                        {{ errorMessage | translate }}
                      </small>
                    </div>
                  }
                </div>
                <div class="lna-row full-width">
                  <label class="form-label lna" for="name">
                    {{ 'pages.researchTopic.workName' | translate }}
                    <span class="required-field">*</span>
                  </label>
                  <div class="textarea-wrapper short">
                    <textarea
                      class="form-control lna"
                      id="nameWork"
                      [ngClass]="{ invalid: shouldRenderError('name') }"
                      type="text"
                      formControlName="name"
                      name="nameWork"
                      required
                      maxlength="{{ maxFieldLength }}"></textarea>
                  </div>
                  @if (getErrorMessage('name', workForm); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message">
                        {{ errorMessage | translate }}
                      </small>
                    </div>
                  }
                </div>
              </div>
              <div class="lna-row full-width">
                <label class="form-label lna" for="address">
                  {{ 'pages.researchTopic.workAddress' | translate }}
                  <span class="required-field">*</span>
                </label>
                <div class="textarea-wrapper short">
                  <textarea
                    class="form-control lna"
                    id="addressWork"
                    [ngClass]="{ invalid: shouldRenderError('address') }"
                    type="text"
                    formControlName="address"
                    name="addressWork"
                    required
                    maxlength="{{ maxFieldLength }}"></textarea>
                </div>
                @if (getErrorMessage('address', workForm); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message">
                      {{ errorMessage | translate }}
                    </small>
                  </div>
                }
              </div>
              <div class="grid-2">
                <div class="lna-row full-width no-margin" >
                  <label class="form-label lna" for="phone">
                    {{ 'pages.researchTopic.workPhone' | translate }}
                    <span class="required-field">*</span>
                  </label>
                  <div class="textarea-wrapper short">
                    <textarea
                      class="form-control lna"
                      id="workPhone"
                      [ngClass]="{ invalid: shouldRenderError('phone') }"
                      type="text"
                      formControlName="phone"
                      name="workPhone"
                      required
                      maxlength="{{ maxLengthPhone }}"></textarea>
                  </div>
                  @if (getErrorMessage('phone', workForm); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message">
                        {{ errorMessage | translate }}
                      </small>
                    </div>
                  }
                </div>
                <div class="lna-row full-width no-margin">
                  <label class="form-label lna" for="email">
                    {{ 'pages.researchTopic.workEmail' | translate }}
                    <span class="required-field">*</span>
                  </label>
                  <div class="textarea-wrapper short">
                    <textarea
                      class="form-control lna"
                      id="workEmail"
                      [ngClass]="{ invalid: shouldRenderError('email') }"
                      type="text"
                      formControlName="email"
                      name="workEmail"
                      required
                      maxlength="{{ maxLengthEmail }}"></textarea>
                  </div>
                  @if (getErrorMessage('email', workForm); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message">
                        {{ errorMessage | translate }}
                      </small>
                    </div>
                  }
                </div>
              </div>
            </form>
          } @else if (hasEducationSection()) {
            <form class="education-form" [formGroup]="educationForm">
              <div class="grid-2">
                <div class="lna-row full-width">
                  <label class="form-label lna" for="registrationNumber">
                    {{ 'pages.researchTopic.eduRegistrationNumber' | translate }}
                    <span class="required-field">*</span>
                  </label>
                  <div class="textarea-wrapper short">
                    <textarea
                      class="form-control lna"
                      id="registrationNumberEdu"
                      [ngClass]="{ invalid: shouldRenderError('registrationNumber') }"
                      type="text"
                      formControlName="registrationNumber"
                      name="registrationNumberEdu"
                      required
                      maxlength="{{ maxLengthRegistrationNumberEducation }}"></textarea>
                  </div>
                  @if (getErrorMessage('registrationNumber', educationForm); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message">
                        {{ errorMessage | translate }}
                      </small>
                    </div>
                  }
                </div>
                <div class="lna-row full-width">
                  <label class="form-label lna" for="name">
                    {{ 'pages.researchTopic.eduName' | translate }}
                    <span class="required-field">*</span>
                  </label>
                  <div class="textarea-wrapper short">
                    <textarea
                      class="form-control lna"
                      id="nameEdu"
                      [ngClass]="{ invalid: shouldRenderError('name') }"
                      type="text"
                      formControlName="name"
                      name="nameEdu"
                      required
                      maxlength="{{ maxFieldLength }}"></textarea>
                  </div>
                  @if (getErrorMessage('name', educationForm); as errorMessage) {
                    <div class="error-wrapper">
                      <small class="error-message">
                        {{ errorMessage | translate }}
                      </small>
                    </div>
                  }
                </div>
              </div> 
              <div class="lna-row full-width">
                <label class="form-label lna" for="faculty">
                  {{ 'pages.researchTopic.faculty' | translate }}
                  <span class="required-field">*</span>
                </label>
                <div class="textarea-wrapper short">
                  <textarea
                    class="form-control lna"
                    id="faculty"
                    [ngClass]="{ invalid: shouldRenderError('faculty') }"
                    type="text"
                    formControlName="faculty"
                    name="faculty"
                    required
                    maxlength="{{ maxLengthFaculty }}"></textarea>
                </div>
                @if (getErrorMessage('faculty', educationForm); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message">
                      {{ errorMessage | translate }}
                    </small>
                  </div>
                }
              </div>
              <div class="lna-row full-width no-margin">
                <label class="form-label lna" for="address">
                  {{ 'pages.researchTopic.eduAddress' | translate }}
                  <span class="required-field">*</span>
                </label>
                <div class="textarea-wrapper short">
                  <textarea
                    class="form-control lna"
                    id="addressEdu"
                    [ngClass]="{ invalid: shouldRenderError('address') }"
                    type="text"
                    formControlName="address"
                    name="addressEdu"
                    required
                    maxlength="{{ maxFieldLength }}"></textarea>
                </div>
                @if (getErrorMessage('address', educationForm); as errorMessage) {
                  <div class="error-wrapper">
                    <small class="error-message">
                      {{ errorMessage | translate }}
                    </small>
                  </div>
                }
              </div>
            </form>
          }
          <div class="lna-row full-width top-seperator">
            <div class="label-wrapper">
              <label class="form-label lna" for="chronologicalBoundaries">
                {{ 'pages.researchTopic.chronologicalBoundaries' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-tooltip text="researchTopicChronologicalBoundariesBackoffice" />
            </div>
            <div class="textarea-wrapper">
              <textarea
                class="form-control lna"
                id="chronologicalBoundaries"
                [ngClass]="{
                  invalid: this.shouldRenderError('chronologicalBoundaries')
                }"
                type="text"
                formControlName="chronologicalBoundaries"
                name="chronologicalBoundaries"
                required
                maxlength="{{ maxFieldLength }}"></textarea>
              <p
                class="length"
                [ngClass]="{
                  invalid: chronologicalBoundaries?.value.length > maxFieldLength
                }">
                {{ chronologicalBoundaries?.value?.length }}/{{ maxFieldLength }}
              </p>
            </div>
            @if (getErrorMessage('chronologicalBoundaries'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message">
                  {{ errorMessage | translate }}
                </small>
              </div>
            }
          </div>
          <div class="lna-row full-width">
            <div class="label-wrapper">
              <label class="form-label lna" for="researchGoalAndAccessReason">
                {{ 'pages.researchTopic.researchGoalAndAccessReason' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-tooltip text="researchTopicResearchGoalAndAccessReasonBackoffice" />
            </div>
            <div class="textarea-wrapper">
              <textarea
                class="form-control lna"
                id="researchGoalAndAccessReason"
                [ngClass]="{
                  invalid: shouldRenderError('researchGoalAndAccessReason')
                }"
                type="text"
                formControlName="researchGoalAndAccessReason"
                name="researchGoalAndAccessReason"
                required
                maxlength="{{ maxFieldLength }}"></textarea>
              <p
                class="length"
                [ngClass]="{
                  invalid: researchGoalAndAccessReason?.value.length > maxFieldLength
                }">
                {{ researchGoalAndAccessReason?.value?.length || 0 }}/{{ maxFieldLength }}
              </p>
            </div>
            @if (getErrorMessage('researchGoalAndAccessReason'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message">
                  {{ errorMessage | translate }}
                </small>
              </div>
            }
          </div>
          <div class="lna-row full-width">
            <div class="label-wrapper">
              <p class="form-label lna">
                {{ 'pages.researchTopic.fileTitle' | translate }}
              </p>
              <app-tooltip text="researchTopicAdditionalFilesBackoffice" />
            </div>
            @if (purpose?.value) {
              <div class="info-row">
                <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
                <p>{{ 'pages.researchTopic.additionalFilesInfo' + purpose?.value | translate }}</p>
              </div>
            }
            <div class="info-row">
              <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
              <p>{{ 'pages.researchTopic.additionalFilesInfo2' | translate }}</p>
            </div>
            <app-file-upload
              [isEditMode]="true"
              [existingFiles]="this.researchTopic?.topicFiles || []"
              [type]="topicFileType"
              [associatedEntityId]="this.topicId!"
              [isSubmitting]="isSubmittingFiles"
              (uploading)="handleFileRequests($event)" />
          </div>
          <div class="lna-row full-width top-seperator no-margin">
            <div class="label-wrapper">
              <label class="form-label lna" for="notes">
                {{ 'pages.researchTopic.notes' | translate }}
              </label>
              <app-tooltip text="researchTopicNotesBackoffice" />
            </div>
            <div class="textarea-wrapper">
              <textarea
                class="form-control lna"
                id="notes"
                [ngClass]="{ invalid: this.shouldRenderError('notes') }"
                type="text"
                formControlName="notes"
                name="notes"
                maxlength="{{ maxFieldLength }}"></textarea>
              <p class="length" [ngClass]="{ invalid: notes?.value?.length > maxFieldLength }">
                {{ notes?.value?.length || 0 }}/{{ maxFieldLength }}
              </p>
            </div>
            @if (getErrorMessage('notes'); as errorMessage) {
              <div class="error-wrapper">
                <small class="error-message">
                  {{ errorMessage | translate }}
                </small>
              </div>
            }
          </div>
        </div>
        <div class="section">
          <div class="lna-row full-width" [ngClass]="{ 'no-margin': !requiresRestrictedAccess?.value }">
            <div class="label-wrapper">
              <label class="form-label lna" for="requiresRestrictedAccess">
                {{ 'pages.researchTopic.requiresRestrictedAccess' | translate }}
                <span class="required-field">*</span>
              </label>
              <app-tooltip text="researchTopicRequiresRestrictedAccessBackoffice" />
            </div>
            <div class="radio-buttons">
              <div class="radio-wrapper">
                <input id="yes" [value]="true" type="radio" formControlName="requiresRestrictedAccess" />
                <label for="active">
                  {{ 'components.form.yes' | translate }}
                </label>
              </div>
              <div class="radio-wrapper">
                <input id="no" [value]="false" type="radio" formControlName="requiresRestrictedAccess" />
                <label for="inactive">
                  {{ 'components.form.no' | translate }}
                </label>
              </div>
              @if (getErrorMessage('requiresRestrictedAccess'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message">
                    {{ errorMessage | translate }}
                  </small>
                </div>
              }
            </div>
          </div>
          @if (requiresRestrictedAccess?.value) {
            <div class="lna-row full-width">
              <div class="label-wrapper">
                <label class="form-label lna" for="restrictedAccessJustification">
                  {{ 'pages.researchTopic.restrictedAccessJustification' | translate }}
                  <span class="required-field">*</span>
                </label>
                <app-tooltip text="restrictedAccessJustificationBackoffice" />
              </div>
              <div class="textarea-wrapper">
                <textarea
                  class="form-control lna"
                  id="restrictedAccessJustification"
                  [ngClass]="{
                    invalid: this.shouldRenderError('restrictedAccessJustification')
                  }"
                  type="text"
                  formControlName="restrictedAccessJustification"
                  name="restrictedAccessJustification"
                  maxlength="{{ maxFieldLength }}"></textarea>
                <p
                  class="length"
                  [ngClass]="{
                    invalid: restrictedAccessJustification?.value?.length > maxFieldLength
                  }">
                  {{ restrictedAccessJustification?.value?.length || 0 }}/{{ maxFieldLength }}
                </p>
              </div>
              @if (getErrorMessage('restrictedAccessJustification'); as errorMessage) {
                <div class="error-wrapper">
                  <small class="error-message">
                    {{ errorMessage | translate }}
                  </small>
                </div>
              }
            </div>
            <div class="lna-row full-width no-margin">
              <div class="label-wrapper">
                <p class="form-label lna">
                  {{ 'pages.researchTopic.justificationFileTitle' | translate }}
                </p>
                <app-tooltip text="justificationFileTitle" />
              </div>
              <div class="info-row">
                <img [attr.alt]="'imgAlt.infoIcon.svg' | translate" src="assets/images/info-blue.svg" />
                <p>
                  {{ 'pages.researchTopic.additionalFilesInfo2' | translate }}
                </p>
              </div>
              <app-file-upload
                [isEditMode]="true"
                [existingFiles]="this.researchTopic?.justificationFiles || []"
                [type]="justificationFileType"
                [associatedEntityId]="this.topicId!"
                [isSubmitting]="isSubmittingFiles"
                (uploading)="handleFileRequests($event)" />
            </div>
          }
        </div>
      </form>
      <div class="actions">
        <button class="secondary back-btn" (click)="back()">
          {{ 'pages.researchTopic.back' | translate }}
        </button>
        <button class="primary add-btn" (click)="submit()">
          {{ topicId ? ('pages.researchTopic.submitEdit' | translate) : ('pages.researchTopic.submitAdd' | translate) }}
        </button>
      </div>
      <app-confirm-modal
        [isOpen]="isOpenConfirmBack"
        (confirm)="back(true)"
        (cancel)="isOpenConfirmBack = false"
        title="unsavedChanges"
        bodyText="unsavedChangesBody"
        confirmText="continue"
        denyText="cancelBack" />
    </div>
  }
</div>
